import { Box, Button, Image, Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useImpressionTracking } from "@outschool/ui-legacy-component-library";
import React from "react";

import CalendarIcon from "../../../../images/sold_out.png";
import ChooseATimeOrClassScheduleRequestButton from "../ctas/ChooseATimeOrClassScheduleRequestButton";

export default function UnavailableActivityBanner({
  activity,
  onClickMoreLikeThis,
}: {
  activity: any;
  onClickMoreLikeThis: () => void;
}) {
  const [impressionNode, setImpressionNode] = React.useState();
  const { t } = useTranslation(
    "client\\components\\detailPage\\availableTimes\\UnavailableActivityBanner",
  );

  useImpressionTracking({
    node: impressionNode,
    trackingLabel: "unavailable_activity_banner",
    uniqueId: activity?.uid,
    sharedProperties: {
      activity_uid: activity?.uid,
    },
    trackViews: true,
  });
  const isSoldOut = activity.isSoldOut;
  const MoreClassesButtonMemo = React.useMemo(() => {
    return (
      <Button variant="outlined" fullWidth onClick={onClickMoreLikeThis}>
        {t`See More Classes Like This`}
      </Button>
    );
  }, [onClickMoreLikeThis, t]);

  return (
    <Box
      sx={(theme: Theme) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingY: "1em",
        marginTop: "1em",
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: "neutral.200",
        [theme.breakpoints.up("md")]: {
          flexDirection: "row",
          paddingY: "3em",
        },
      })}
      ref={setImpressionNode}
    >
      <Image
        src={typeof CalendarIcon === "string" ? CalendarIcon : CalendarIcon.src}
        width="120"
        height="120"
        alt={t`Calendar icon`}
        sx={(theme: Theme) => ({
          marginBottom: "1em",
          [theme.breakpoints.up("md")]: {
            marginBottom: 0,
            marginRight: "3em",
          },
        })}
      />
      <Box
        sx={(theme: Theme) => ({
          textAlign: "center",
          [theme.breakpoints.up("md")]: {
            textAlign: "left",
          },
        })}
      >
        <Typography variant="h5">
          {isSoldOut
            ? t`All classes have sold out.`
            : t`There are no open spots for this class.`}
        </Typography>
        {activity.isPublished && (
          <Typography
            component="div"
            sx={{
              marginTop: "0.5em",
            }}
          >
            {t`You can request another time or scroll down to find more classes like this.`}
          </Typography>
        )}
        <Box
          sx={(theme: Theme) => ({
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.up("md")]: {
              flexDirection: "row",
            },
            alignItems: "center",
            gap: "1em",
            marginTop: "1em",
          })}
        >
          {activity.isPublished && (
            <ChooseATimeOrClassScheduleRequestButton
              activity={activity}
              leader={activity.leader}
              variant="contained"
              /* eslint-disable-next-line i18next/no-literal-string */
              locationRenderedOn="AvailableTimesTable"
            />
          )}
          <Box>{MoreClassesButtonMemo}</Box>
        </Box>
      </Box>
    </Box>
  );
}
